import * as gameErrors from '../Errors'

const ERRORS = {
  player_not_found: { action: 'redirect', target: 'students_platform' },
  demo_completed: { action: 'showError', target: gameErrors.DEMO_FINISHED },
  complete_demo_error: { action: 'reload' },
  after_demo_error: { action: 'redirect', target: 'students_platform' },
  NO_TOKEN: { action: 'redirect', target: 'students_platform' },
}

export default ERRORS
